import React from 'react';
import {
  Datagrid,
  NumberField,
  ReferenceManyField,
  TextField,
  ReferenceField,
  useTranslate,
} from 'react-admin';

import { GridCard, Pagination } from '../../../components';

const EquipmentCard = (props) => {
  const translate = useTranslate();

  return (
    <GridCard
      {...props}
      title={translate('resources.account.card_title.equipment')}
      xs={12}
    >
      <ReferenceManyField
        addLabel={false}
        reference="provider_item"
        target="account_id"
        filter={{ type: 'EQUIPMENT' }}
        sort={{ field: 'quantity', order: 'DESC' }}
        xs={12}
        pagination={<Pagination />}
      >
        <Datagrid>
          <ReferenceField link="show" source="provider" reference="account">
            <TextField source="name" />
          </ReferenceField>
          <TextField source="provider_item_ref_id" />
          <TextField source="provider_item_name" />
          <NumberField source="quantity" />
        </Datagrid>
      </ReferenceManyField>
    </GridCard>
  );
};

export default EquipmentCard;
